module.exports = __webpack_public_path__ + "9c66fd3fa168f20a004114b8040904e3.png";